<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { i18n } from '@/i18n';
import { loadMyPropertyPreferences, myPropertyPreferences, saveMyPropertyPreferences } from '@/appLogic/view/preferences';
import { supportedLang } from '@/coreDomainsModule/i18n';

const t = i18n.t;

onMounted(async () => {
  await loadMyPropertyPreferences();
  const lang = myPropertyPreferences.language;
  if (i18n) i18n.locale = lang ?? 'ja';
});

/**
 * 選択されている言語情報
 */
const selectLang = computed((): string => {
  if (!i18n) return 'en';
  return i18n.locale;
});

/**
 * 選択言語切り替え処理
 */
const changeLang = async () => {
  // なんか型が...
  let targetLang: supportedLang = 'ja';

  // 切り替え先の表示言語ハンドリング
  switch (selectLang.value) {
    case 'ja':
      targetLang = 'en';
      break;
    case 'en':
      targetLang = 'ja';
      break;
    default:
      targetLang = 'ja';
  }
  if (i18n && i18n) i18n.locale = targetLang;
  myPropertyPreferences.language = targetLang;
  await saveMyPropertyPreferences();
};
</script>

<template>
  <div class="change_lang_btn">
    <span @click="changeLang">{{ t('Lang') + ': ' + selectLang }}</span>
  </div>
</template>

<style lang="scss" scoped>
.change_lang_btn {
  cursor: pointer;
  user-select: none;
  margin: 0px 8px 16px 16px;
}
</style>
